import React, { useState, useEffect } from 'react';
import {Table, Tag, Space, Spin, Alert, Card, Button} from 'antd';
import {
    ArrowRightOutlined,
    UserOutlined,
    InfoCircleOutlined,
    CalendarOutlined, ReloadOutlined
} from '@ant-design/icons';
import axios from 'axios';
import {instance} from "../../API/API";

const HistoryTable = ({ itemId, itemName, change }) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);

    const fetchTransferHistory = async () => {
        if (!itemId) return;

        setLoading(true);
        setError(null);
        try {
            const response = await instance.get(`store/get_transfer_history.php?item_id=${itemId}`);
            console.log(response.data.success);
            if (response.data.success) {
                setData(response.data.transfer_history || []);
            } else {
                throw new Error(response.data.error || 'Failed to fetch transfer history');
            }
        } catch (err) {
            console.error('Error fetching transfer history:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        itemId && fetchTransferHistory();
    }, [itemId, change]);


    console.log(data);

    const columns = [
        {
            title: 'Дата перемещения',
            dataIndex: 'date',
            key: 'date',
            width: 160,
            render: (date) => (
                <Space>
                    <CalendarOutlined />
                    {new Date(+date).toLocaleString('ru-RU')}
                </Space>
            ),
            sorter: (a, b) => new Date(a.date) - new Date(b.date),
            defaultSortOrder: 'descend',
        },
        {
            title: 'Откуда',
            dataIndex: 'from_store',
            key: 'from_store',
            width: 120,
            render: (from_store) => (
                from_store ? (
                    <Tag color="blue">{from_store.name}</Tag>
                ) : (
                    <Tag color="default">Внешний источник</Tag>
                )
            ),
        },
        {
            title: '',
            key: 'arrow',
            width: 40,
            align: 'center',
            render: () => <ArrowRightOutlined style={{ color: '#1890ff' }} />,
        },
        {
            title: 'Куда',
            dataIndex: 'to_store',
            key: 'to_store',
            width: 120,
            render: (to_store) => (
                to_store ? (
                    <Tag color="green">{to_store.name}</Tag>
                ) : (
                    <Tag color="default">Внешний получатель</Tag>
                )
            ),
        },
        {
            title: 'Количество',
            dataIndex: 'quantity',
            key: 'quantity',
            width: 100,
            align: 'center',
            render: (quantity) => (
                <Tag color="orange" style={{ fontWeight: 'bold' }}>
                    {quantity}
                </Tag>
            ),
        },
        {
            title: 'Ответственный',
            dataIndex: 'owner',
            key: 'owner',
            width: 120,
            render: (owner) => (
                owner ? (
                    <Space>
                        <UserOutlined />
                        {owner.full_name}
                    </Space>
                ) : (
                    <Tag color="default">Не указан</Tag>
                )
            ),
        },
        {
            title: 'Описание',
            dataIndex: 'description',
            key: 'description',
            render: (description) => (
                description ? (
                    <Space>
                        <InfoCircleOutlined />
                        {description}
                    </Space>
                ) : (
                    <span style={{ color: '#999', fontStyle: 'italic' }}>Нет описания</span>
                )
            ),
        },
    ];

    if (error) {
        return (
            <Card title={`История перемещений: ${itemName}`}>
                <Alert
                    message="Ошибка загрузки"
                    description={error}
                    type="error"
                    showIcon
                />
                <div style={{ marginTop: 16, textAlign: 'center' }}>
                    <Button onClick={fetchTransferHistory} type="primary">
                        Попробовать снова
                    </Button>
                </div>
            </Card>
        );
    }

    return (
        <Card
            title={
                <Space>
                    <span>История перемещений</span>
                    {itemName && (
                        <Tag color="purple">{itemName}</Tag>
                    )}
                </Space>
            }
            extra={
                <Button
                    onClick={fetchTransferHistory}
                    loading={loading}
                    icon={<ReloadOutlined />}
                    size="small"
                >
                    Обновить
                </Button>
            }
        >
            <Table
                columns={columns}
                dataSource={data.map(item => ({ ...item, key: item.id }))}
                loading={loading}
                size="small"
/*                pagination={{
                    pageSize: 10,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) =>
                        `Записи ${range[0]}-${range[1]} из ${total}`,
                }}*/
                pagination={false}
                scroll={{ x: 800 }}
                locale={{
                    emptyText: 'Нет данных о перемещениях'
                }}
            />
        </Card>
    );
};

export default HistoryTable;